import { render, staticRenderFns } from "./CashflowDetail.vue?vue&type=template&id=26f2f6fb&"
import script from "./CashflowDetail.vue?vue&type=script&lang=js&"
export * from "./CashflowDetail.vue?vue&type=script&lang=js&"
import style0 from "./CashflowDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VNavigationDrawer,VSimpleTable})
